<template>
    <div class="pt-8">
        <!-- Alerta para batch en progreso -->
        <b-alert 
            v-if="activeBatch && activeBatch.status === 'processing'" 
            show 
            variant="info" 
            class="mb-3">
            <div class="d-flex justify-content-between align-items-center">
                <div>
                    <b-icon icon="clock" class="mr-2"></b-icon>
                    <strong>Envío masivo en progreso</strong>
                    <br>
                    <small>Iniciado: {{ formatDate(activeBatch.started_at) }}</small>
                    <br>
                    <span>Procesados: {{ activeBatch.processed }}/{{ activeBatch.total }}</span>
                </div>
                <div class="text-right">
                    <b-progress 
                        :value="activeBatch.processed" 
                        :max="activeBatch.total" 
                        style="width: 200px"
                        class="mb-2">
                    </b-progress>
                    <b-button 
                        size="sm" 
                        variant="outline-primary" 
                        @click="refreshBatchStatus">
                        <b-icon icon="arrow-clockwise"></b-icon> Actualizar
                    </b-button>
                </div>
            </div>
        </b-alert>

        <filter-form 
            :filter="filter" 
            :departamentosList="departamentosList" 
            :ciudadesList="ciudadesList"
            @get-pedidos="getPedidos()" 
            @clear-filter-form="clearFilterForm()" 
            @get-ciudades-list="getCiudadesList()" 
        />
        
        <pedidos-table 
            :pedidos="pedidos" 
            :paginator="paginator" 
            :pageSize="pageSize"
            :canSeeSalesComission="canSeeSalesComission"
            :odooIstances="odooIstances"
            @get-pedidos="getPedidos()" 
            @change-page="changePage($event)" 
            @download-excel="downloadOrderTemplate()"
            @upload-excel="openExcelModal()"
            @show-guide-upload-modal="showUploadModal"
            @send-batch-orders="showBatchOdooModal"
            ref="pedidosTable"
        />

        <ExcelUploadModal 
            :modalVisible="showExcelModal" 
            :isLoading="isLoading"
            @close-modal="showExcelModal = false"
            @loading-change="handleLoadingChange"
            @orders-processed="handleOrdersProcessed"
            ref="excelUploadModal"
        />

        <guide-pdf-upload-modal
            v-if="isPdfModalVisible"
            :modal-visible="isPdfModalVisible"
            :is-loading="isUploading"
            :order-id="currentOrderId"
            :order-data="currentOrderData"
            @close-modal="isPdfModalVisible = false"
            @upload-pdf="handlePdfUpload"
        />

        <!-- Modal para envío masivo a Odoo -->
        <send-batch-to-odoo-modal
            v-if="isBatchOdooModalVisible"
            :modal-visible="isBatchOdooModalVisible"
            :order-ids="selectedOrderIds"
            :orders-count="selectedOrderIds.length"
            :odoo-instances="odooIstances"
            :is-sending="isSendingBatch"
            @close-modal="closeBatchOdooModal"
            @send-batch-to-odoo="sendBatchToOdoo"
        />
        
    </div>
</template>
<script>
import PedidosTable from '../components/PedidosTable.vue'
import FilterForm from '../components/FilterForm.vue'
import ExcelUploadModal from '../components/ExcelUploadModal.vue';
import GuidePdfUploadModal from '../components/GuidePdfUploadModal.vue';
import SendBatchToOdooModal from '../components/SendBatchToOdooModal.vue';
import { mapMutations, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            pedidos: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            filter:{
                pedidoId: "",
                vendedor: "",
                cliente: "",
                nit: "",
                departamento: "",
                ciudad: "",
                dateFrom: "",
                dateTo: new Date().toISOString().substr(0, 10),
            },
            departamentosList: [],
            ciudadesList: [],
            canSeeSalesComission: false,
            showExcelModal: false,
            isLoading: false,
            isPdfModalVisible: false,
            isUploading: false,
            currentOrderId: null,
            currentOrderData: null,
            
            // Nuevas variables para Odoo
            odooIstances: [],
            isBatchOdooModalVisible: false,
            selectedOrderIds: [],
            isSendingBatch: false,
            activeBatch: null // Para mostrar batch en progreso
        }
    },
    components: {
        PedidosTable,
        FilterForm,
        ExcelUploadModal,
        GuidePdfUploadModal,
        SendBatchToOdooModal
    },
    created(){
        this.getPedidos();
        this.getDepartamentosList();
        this.checkLastBatchStatus(); // Consultar estado de envíos masivos
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPedidos() {
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                pedidoId:     this.filter.pedidoId,
                vendedor:     this.filter.vendedor,
                cliente:      this.filter.cliente,
                nit:          this.filter.nit,
                departamento: this.filter.departamento,
                ciudad:       this.filter.ciudad,
                dateFrom:     this.filter.dateFrom,
                dateTo:       this.filter.dateTo,
            }
            if(this.user.permissions.includes('can_supervise_sales_comission') 
            || this.user.permissions.includes('can_access_to_own_sales_comission_detail')){
                this.canSeeSalesComission = true;
            }
            this.setLoading(true)
            await this.$conectar.post('pedidos/get-pedidos', this.pageOptions)
            .then(response =>{
                this.pedidos = response.data.pedidosLists;
                this.paginator.totalPage = response.data.totalPages;
                this.odooIstances = response.data.odooInstances || response.data || [];
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        
        // Método para cargar las instancias de Odoo
        
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentosList = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            if(this.filter.departamento != ''){
                this.filter.ciudad = "";
                this.departamentoSelected = { 
                    departamento_id:   this.filter.departamento, 
                }
                this.setLoading(true)
                await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
                .then(response =>{
                    this.ciudadesList = response.data.ciudadesList;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.setLoading(false)
            }else{
                this.ciudadesList = [];
            }
        },
        changePage(page){
            this.paginator.page = page;
            this.getPedidos();
        },
        clearFilterForm(){
            this.filter.pedidoId = "";
            this.filter.vendedor = "";
            this.filter.cliente = "";
            this.filter.nit = "";
            this.filter.departamento = "";
            this.filter.ciudad = "";
            this.filter.dateFrom = "";
            this.filter.dateTo = new Date().toISOString().substr(0, 10);
            this.paginator.pageSize = 10;
        },
        
        
        // Método para consultar estado de envíos masivos
        async checkLastBatchStatus() {
            try {
                const response = await this.$conectar.get('odoo-client-order/last-batch-status');
                
                if (response.data.has_recent_batch) {
                    const batch = response.data.batch;
                    
                    if (batch.status === 'completed') {
                        this.showBatchCompletionToast(batch);
                    } else if (batch.status === 'processing') {
                        this.activeBatch = batch;
                        this.showBatchInProgressToast(batch);
                    } else if (batch.status === 'failed') {
                        this.showBatchFailedToast(batch);
                    }
                }
            } catch (e) {
                console.log('Error checking batch status:', e);
                // Error silencioso, no es crítico
            }
        },
        
        // Método para actualizar estado de batch manualmente
        async refreshBatchStatus() {
            if (!this.activeBatch) return;
            
            try {
                const response = await this.$conectar.get(`odoo-client-order/batch-status/${this.activeBatch.id}`);
                
                if (response.data.batch) {
                    const updatedBatch = response.data.batch;
                    
                    if (updatedBatch.status === 'completed') {
                        this.activeBatch = null;
                        this.showBatchCompletionToast(updatedBatch);
                        this.getPedidos(); // Actualizar lista para ver cambios
                    } else if (updatedBatch.status === 'failed') {
                        this.activeBatch = null;
                        this.showBatchFailedToast(updatedBatch);
                        this.getPedidos();
                    } else {
                        this.activeBatch = updatedBatch;
                    }
                }
            } catch (e) {
                console.log('Error refreshing batch status:', e);
            }
        },
        
        // Toast para batch completado
        showBatchCompletionToast(batch) {
            const successCount = batch.successful || 0;
            const failedCount = batch.failed || 0;
            const totalCount = batch.total || 0;
            
            if (failedCount === 0) {
                // Todos exitosos
                this.$bvToast.toast(
                    `Se enviaron ${successCount} de ${totalCount} pedidos correctamente a Odoo.`,
                    {
                        title: "✅ Envío masivo completado",
                        variant: "success",
                        solid: true,
                        autoHideDelay: 8000
                    }
                );
            } else {
                // Algunos fallaron
                this.$bvToast.toast(
                    `Enviados: ${successCount}/${totalCount}\nFallaron: ${failedCount} pedidos\n\nPuedes reenviar los que fallaron.`,
                    {
                        title: "⚠️ Envío masivo finalizado con errores",
                        variant: "warning",
                        solid: true,
                        autoHideDelay: 10000
                    }
                );
            }
        },
        
        // Toast para batch en progreso
        showBatchInProgressToast(batch) {
            this.$bvToast.toast(
                `Hay un envío masivo en progreso: ${batch.processed}/${batch.total} procesados.`,
                {
                    title: "🔄 Envío en progreso",
                    variant: "info",
                    solid: true,
                    autoHideDelay: 5000
                }
            );
        },
        
        // Toast para batch fallido
        showBatchFailedToast() {
            this.$bvToast.toast(
                `El envío masivo falló. Revisa los logs o contacta al administrador.`,
                {
                    title: "❌ Error en envío masivo",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 8000
                }
            );
        },
        
        // Método para formatear fechas
        formatDate(dateString) {
            if (!dateString) return '';
            
            const date = new Date(dateString);
            return date.toLocaleString('es-CO', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        
        // Nuevos métodos para envío masivo a Odoo
        showBatchOdooModal(orderIds) {
            this.selectedOrderIds = orderIds;
            this.isBatchOdooModalVisible = true;
        },
        
        closeBatchOdooModal() {
            this.isBatchOdooModalVisible = false;
            this.selectedOrderIds = [];
        },
        
        async sendBatchToOdoo(odooInstanceId) {
            // Cambiar el estado en la tabla a "enviando"
            this.$refs.pedidosTable.startBatchSending();
            this.isSendingBatch = true;
            
            try {
                const response = await this.$conectar.post('odoo-client-order/send-batch-orders', {
                    order_ids: this.selectedOrderIds,
                    odoo_id: odooInstanceId
                });
                
                if (response.data.success === true) {
                    this.$bvToast.toast(response.data.message, 
                        {
                            title: "Envío masivo iniciado",
                            variant: "success",
                            solid: true
                        }
                    );
                    
                    // Actualizar la tabla
                    this.getPedidos();
                    
                    // Limpiar selección en la tabla
                    this.$refs.pedidosTable.finishBatchSending();
                    
                } else {
                    this.$bvToast.toast(response.data.message, {
                        title: "Error en el envío masivo",
                        variant: "danger",
                        solid: true
                    });
                    
                    // Solo resetear el estado de envío, mantener selección
                    this.$refs.pedidosTable.sendingBatch = false;
                }
                
            } catch (e) {
                console.log(e.response);
                
                let errorMessage = "Error al conectar con el servidor";
                if (e.response && e.response.data && e.response.data.message) {
                    errorMessage = e.response.data.message;
                }
                
                this.$bvToast.toast(errorMessage, {
                    title: "Error en el envío masivo",
                    variant: "danger",
                    solid: true
                });
                
                // Solo resetear el estado de envío, mantener selección para reintentar
                this.$refs.pedidosTable.sendingBatch = false;
            } finally {
                this.isSendingBatch = false;
                this.closeBatchOdooModal();
            }
        },
        
        async downloadOrderTemplate() {
            this.setLoading(true);
            try {
                // Hacer petición al endpoint que descarga la plantilla
                const response = await this.$conectar.post(
                    'pedidos/download-order-template-excel',
                    {}, // Cuerpo vacío o datos que necesites enviar
                    { 
                        responseType: 'blob', // Esto debe ir en las opciones, no en el cuerpo
                        headers: {
                            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    }
                );

                // Verificar respuesta
                if (!response.data || response.data.size === 0) {
                    throw new Error('Archivo vacío recibido');
                }


                // Crear y descargar archivo
                const blob = new Blob([response.data], { 
                    type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                });
                
                // Método más confiable para descargar
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                
                const today = new Date();
                const date = today.getFullYear() + '-' + 
                            ('0' + (today.getMonth() + 1)).slice(-2) + '-' + 
                            ('0' + today.getDate()).slice(-2);
                // Configurar enlace
                link.href = url;
                link.setAttribute('download', `pedidos_template_${date}.xlsx`);
                document.body.appendChild(link);
                
                // Descargar y limpiar
                link.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

            } catch (error) {
                console.error('Error descargando archivo:', error);
                
                // Manejo de error más específico
                let errorMessage = 'Error descargando la plantilla Excel';
                
                if (error.response) {
                    // El servidor respondió con un código de estado diferente de 2xx
                    errorMessage += `: ${error.response.status} ${error.response.statusText}`;
                    
                    // Intentar leer el cuerpo del error si es posible
                    if (error.response.data instanceof Blob) {
                        try {
                            const text = await error.response.data.text();
                            const jsonError = JSON.parse(text);
                            errorMessage += ` - ${jsonError.message || 'Error desconocido'}`;
                        } catch (e) {
                            // No podemos leer el error como JSON
                        }
                    }
                } else if (error.request) {
                    // La solicitud se realizó pero no se recibió respuesta
                    errorMessage += ': No se recibió respuesta del servidor';
                } else {
                    // Error al configurar la solicitud
                    errorMessage += `: ${error.message}`;
                }
                
                this.$bvToast.toast(errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.setLoading(false);
            }
        },
        openExcelModal() {
            this.showExcelModal = true;
        },
        
        showUploadModal(orderId, orderData) {
            // Verificar si el usuario tiene permiso para subir PDF
            if (this.user.isMaster !== 1) {
                this.$bvToast.toast("No tienes permisos para realizar esta acción", {
                    title: "Acceso denegado",
                    variant: "warning",
                    solid: true
                });
                return;
            }
            
            // Formatear los datos del pedido para el modal
            const formattedOrderData = {
                customer: orderData.nombre_cliente || '',
                date: orderData.created_at || '',
            };

            // Actualizar los datos en el estado
            this.currentOrderId = orderId;
            this.currentOrderData = formattedOrderData;
            this.isPdfModalVisible = true;
        },
        async handlePdfUpload(formData) {
            this.isUploading = true;
            try {
                const response = await this.$conectar.post('pedidos/upload-guide-pdf', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                
                if (response.data.error === false) {
                    this.$bvToast.toast(response.data.message || "Guía PDF cargada con éxito", {
                        title: "PDF cargado exitosamente",
                        variant: "success",
                        solid: true
                    });
                    
                    // Cerrar el modal después de subir exitosamente
                    this.isPdfModalVisible = false;
                    
                    // Actualizar la lista de pedidos para reflejar el cambio
                    this.getPedidos();
                } else {
                    this.$bvToast.toast(response.data.message || "Ocurrió un error al cargar el PDF", {
                        title: "Error al cargar el PDF",
                        variant: "danger",
                        solid: true
                    });
                }
            } catch (e) {
                console.error("Error al subir el PDF:", e);
                
                let errorMessage = "Parece que hubo un error al conectar con el servidor";
                
                if (e.response && e.response.data && e.response.data.message) {
                    errorMessage = e.response.data.message;
                }
                
                this.$bvToast.toast(errorMessage, {
                    title: "Error al cargar el PDF",
                    variant: "danger",
                    solid: true
                });
            } finally {
                this.isUploading = false;
            }
        },
        handleOrdersProcessed(successCount) {
            this.$bvToast.toast(`Se procesaron ${successCount} pedidos correctamente`, {
                title: 'Éxito',
                variant: 'success',
                solid: true
            });
            this.getPedidos(); // Actualizar la lista de pedidos
        },
        handleLoadingChange(isLoading) {
            this.isLoading = isLoading;
        },
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>